<div class="contraventions-question" *ngIf="valuesSelected.length > 0 && options.length > 0">
  <div class="default-text large">
    <a (click)="updateAllContraventions()" [ngClass]="{'disabled': !active}">
      <strong>Click here</strong></a>
    to set all contraventions to
    <span class="select-layer" [ngClass]="{'disabled': !active}">
      <select class="app-select" [disabled]="!active"
              (change)="allContraventionsValue = $event.target.value">
        <option [value]="option.value" *ngFor="let option of options"
                [selected]="option.value === 'n'">{{option.text}}</option>
      </select>
    </span>
    .
  </div>
  <div class="question-block" *ngFor="let contravention of contraventions">
    <label class="form-group">
      <span class="default-title" [ngbPopover]="contraventionPopover" triggers="hover" placement="top">
        {{contravention.id}}:
      </span>
      <ng-template #contraventionPopover>
        <div [innerHTML]="contravention.description | safe: 'html'"></div>
      </ng-template>
      <span class="select-layer" [ngClass]="{'disabled': !active}">
        <select class="app-select" [disabled]="!active"
                (change)="onAnswerSelected($event.target.value, contravention)">
          <option *ngFor="let option of options" [value]="option.value"
                  [selected]="isContraventionValueSelected(contravention, option.value)">
            {{option.text}}
          </option>
        </select>
      </span>
    </label>
  </div>
</div>
